module.exports = __webpack_public_path__ + "img/03.cb26ced5.webp";